<template lang="pug">
#formulario-territorio-gleba-operacao(
    :class='dadosVisualizacao ? "formulario-territorio-gleba-operacao--visualizar" : ""'
)
    .formulario-dados-territorio-gleba
        el-form.form(label-position='top', size='small')
            el-form-item.w-66(v-if='!dadosVisualizacao')
                template(slot='label')
                    span.campo_obrigatorio {{ $t('mensagens.operacao.formularioGleba.territorio') }}
                el-select.w-100(
                    v-model='territorio',
                    @change='adicionarTerritorio',
                    @blur='fecharResultadoPesquisa',
                    @focus='verificarResultadoTerritorios',
                    :placeholder='$t("mensagens.operacao.formularioGleba.buscarTerritorio")',
                    filterable,
                    remote,
                    reserve-keyword,
                    :remote-method='remoteMethod'
                )
                    el-option(
                        v-show='mostrarResultado',
                        v-for='territorio in territorios',
                        :key='"territorio" + territorio.id',
                        :label='territorio.nome',
                        :value='territorio'
                    )

        .lista-territorio(v-loading='territorioLoading')
            span.titulo {{ $t('mensagens.operacao.formularioGleba.territoriosAdicionados') }}
            el-row(
                v-for='(territorio, territorioIndex) in territoriosAdicionados',
                :key='territorioIndex'
            )
                .lista-territorio__body
                    el-col.lista-territorio__mapa(:span='5')
                        div
                            .lista-territorio__mapa-preview(
                                :id='territorio.nome + territorio.id'
                            )
                        .lista-territorio__actions(v-if='!dadosVisualizacao')
                            BaseButton(
                                type='outline'
                                size='mini',
                                icon='el-icon-copy-document',
                                @click='abrirModalUtilizarAreaTotalTerritorio(territorio, territorioIndex)',
                                :disabled='territorio.utilizouAreaTotalTerritorio'
                            ) {{ $t('mensagens.operacao.formularioGleba.utilizarAreaTotal') }}
                            el-popconfirm(
                                :title='$t("mensagens.operacao.formularioGleba.confirmacaoRemoverTerritorio")',
                                @confirm='removerTerritorio(territorio)'
                            )
                                BaseButton(
                                    size='mini',
                                    type='danger',
                                    icon='el-icon-delete',
                                    slot='reference'
                                ) {{ $t('mensagens.operacao.acoes.remover') }}

                    el-col(:span='19')
                        el-row
                            el-col.lista-territorio__nome(:span='7')
                                div
                                    span.titulo-tabela {{ $t('mensagens.operacao.tabela.nome') }}
                                    p {{ territorio.nome }}
                            el-col(:span='3')
                                div
                                    span.titulo-tabela {{ $t('mensagens.operacao.formularioGleba.localidade') }}
                                    p {{ territorio.localidade }}
                            el-col(:span='2')
                                div
                                    span.titulo-tabela {{ $t('mensagens.operacao.formularioGleba.areaHa') }}
                                    p {{ territorio.area }}
                            el-col(:span='6')
                                .isCursorPointer(
                                    v-if='territorio.pessoa.length > 1',
                                    @click='pessoasSelecionadas = territorio.pessoa'
                                )
                                    el-badge(
                                        :value='"+" + (territorio.pessoa.length - 1)',
                                        type='success'
                                    )
                                        span.titulo-tabela {{ $t('mensagens.operacao.pessoasVinculadas') }}
                                    p {{ territorio.primeiraPessoa }}
                                div(v-else)
                                    span.titulo-tabela {{ $t('mensagens.operacao.pessoaVinculada') }}
                                    p {{ territorio.primeiraPessoa }}
                            el-col.lista-territorio__primeiro-car(:span='6')
                                .isCursorPointer(
                                    v-if='territorio.car.length > 1',
                                    @click='carsSelecionados = territorio.car'
                                )
                                    el-badge(
                                        :value='"+" + (territorio.car.length - 1)',
                                        type='success'
                                    )
                                        span.titulo-tabela {{ $t('mensagens.comuns.carsVinculados') }}
                                    p {{ territorio.primeiroCar }}
                                div(v-else)
                                    span.titulo-tabela {{ $t('mensagens.operacao.carVinculado') }}
                                    p {{ territorio.primeiroCar }}

                        el-divider

                        el-row.lista-glebas
                            .lista-glebas__header
                                h3 {{ $t('mensagens.operacao.formularioGleba.glebasAdicionadas') }}
                                BaseButton(
                                    v-if='!dadosVisualizacao',
                                    type='primary',
                                    icon='el-icon-plus',
                                    size='mini',
                                    @click='adicionarNovaGleba(territorio, territorioIndex)'
                                ) {{ $t('mensagens.operacao.formularioGleba.novaGleba') }}
                            .lista-glebas__table
                                el-table(
                                    :data='territorio.glebas',
                                    style='width: 100%',
                                    border,
                                    @cell-mouse-enter='highlightGlebaMapaPreviewEnter',
                                    @cell-mouse-leave='highlightGlebaMapaPreviewLeave'
                                )
                                    el-table-column.titulo-tabela(
                                        prop='operacaoIdentificadorGleba',
                                        :label='$t("mensagens.operacao.formularioGleba.identificacao")'
                                    )
                                    el-table-column.titulo-tabela(
                                        prop='tipo.nome',
                                        :label='$t("mensagens.operacao.formularioGleba.tipo")'
                                    )
                                    el-table-column.titulo-tabela(
                                        prop='area',
                                        :label='$t("mensagens.operacao.formularioGleba.areaHa")'
                                    )
                                    el-table-column.titulo-tabela(
                                        v-if='!dadosVisualizacao',
                                        :label='$t("mensagens.operacao.tabela.acoes")'
                                    )
                                        template(slot-scope='scope')
                                            .lista-glebas__actions
                                                BaseButton(
                                                    size='mini',
                                                    icon='el-icon-edit',
                                                    @click='editarGleba(scope.row, territorio, territorioIndex)'
                                                ) {{ $t('mensagens.operacao.acoes.editar') }}
                                                el-popconfirm(
                                                    :title='$t("mensagens.operacao.formularioGleba.confirmacaoRemoverGleba")',
                                                    @confirm='removerGleba(scope.row, territorioIndex)'
                                                )
                                                    BaseButton(
                                                        size='mini',
                                                        type='danger',
                                                        icon='el-icon-delete',
                                                        slot='reference'
                                                    ) {{ $t('mensagens.operacao.acoes.remover') }}
                                    template(slot='empty')
                                    .w-100(style='text-align: center')
                                        .lista-vazia
                                            span {{ $t('mensagens.operacao.formularioGleba.nenhumaGlebaAdicionada') }}

                el-divider

            .w-100(style='text-align: center')
            .lista-vazia(
                v-if='!territoriosAdicionados.length',
                :span='24',
                style='padding: 0; text-align: center'
            )
                span {{ $t('mensagens.operacao.formularioGleba.nenhumTerritorioAdicionado') }}

    .modal-desenhar-gleba
        el-dialog(
            v-if='mostrarModalModalPrincipal',
            :visible.sync='mostrarModalModalPrincipal',
            fullscreen,
            :close-on-press-escape='false',
            :show-close='false'
        )
            #modal-desenhar-gleba__mapa

            .modal-desenhar-gleba__list
                .modal-desenhar-gleba-list__content
                    h3 {{ $t('mensagens.operacao.formularioGleba.glebasUtilizadasOperacoesAnteriores') }}
                    el-input(
                        prefix-icon='el-icon-search',
                        :placeholder='$t("mensagens.operacao.formularioGleba.buscarOperacao")',
                        clearable,
                        maxlength='50',
                        minlength='3',
                        v-model='pesquisaGleba',
                        @change='pesquisarGleba()'
                    )
                    .modal-desenhar-gleba-list__item.is-always-shadow(
                        v-for='(gleba, glebaIndex) in glebas',
                        :key='glebaIndex'
                    )
                        .modal-desenhar-gleba-list__mapa(
                            :id='gerarIdMapa(gleba.operacaoIdentificadorGleba, gleba.id)'
                        )
                        div
                            span.titulo-tabela {{ $t('mensagens.operacao.operacao') }}:
                            span {{ gleba.operacaoNome }}
                        div
                            span.titulo-tabela {{ $t('mensagens.operacao.formularioGleba.identificadorOperacao') }}:
                            span {{ gleba.operacaoIdentificador }}
                        div
                            span.titulo-tabela {{ $t('mensagens.operacao.formularioGleba.identificadorGleba') }}:
                            span {{ gleba.operacaoIdentificadorGleba }}
                        div
                            span.titulo-tabela {{ $t('mensagens.operacao.formularioGleba.areaHa') }}:
                            span {{ gleba.area }}
                        .modal-desenhar-gleba-list__button
                            BaseButton(
                                size='mini',
                                type='primary',
                                icon='el-icon-plus',
                                :disabled='!!glebaAdicionadaMapaPrincipal.geometria',
                                @click='adicionarGlebaOperacaoAnteriorMapa(gleba)'
                            ) {{ $t('mensagens.operacao.acoes.adicionar') }}
                    div(v-if='!glebas.length')
                        .lista-vazia
                            el-empty(
                                :image-size='100',
                                :description='$t("mensagens.operacao.formularioGleba.nenhumaGlebaEncontrada")'
                            )

                .modal-desenhar-gleba__button
                    BaseButton(
                        icon='el-icon-close',
                        @click='limparDadosNovaGleba()'
                    ) {{ $t('mensagens.operacao.acoes.cancelar') }}
                    BaseButton(
                        type='primary',
                        icon='el-icon-check',
                        @click='abrirModalFinalizarCadastroGeometriaGleba()'
                    ) {{ $t('mensagens.operacao.acoes.finalizar') }}

    .modal-utilizar-area-total-territorio
        el-dialog(
            v-if='mostrarModalSelecaoGlebaTipo',
            :title='$t("mensagens.operacao.formularioGleba.utilizarAreaTotalTerritorio")',
            :visible.sync='mostrarModalSelecaoGlebaTipo',
            width='30%',
            :close-on-click-modal='false',
            :show-close='false'
        )
            div
                strong {{ $t('mensagens.operacao.formularioGleba.identificadorGleba') }}
                p {{ territorioUtilizarAreaTotal.nome }}
            div
                strong {{ $t('mensagens.operacao.formularioGleba.areaHa') }}
                p {{ territorioUtilizarAreaTotal.area }}
            div
                strong {{ $t('mensagens.operacao.formularioGleba.selecionarTipoGleba') }}
                el-form(
                    :model='formularioGlebaTipo',
                    ref='formularioGlebaTipo',
                    :rules='regraFormularioGlebaTipos'
                )
                    el-form-item(prop='glebaTipo', required)
                        el-radio.modal-utilizar-area-total-territorio__radio(
                            v-model='formularioGlebaTipo.glebaTipo',
                            :label='glebaTipo',
                            v-for='(glebaTipo, glebaTipoIndex) in glebaTipos',
                            :key='glebaTipoIndex'
                        ) {{ glebaTipo.nome }}
            span.dialog-footer(slot='footer')
                BaseButton.mt-3(@click='cancelarUtilizarAreaTotalTerritorio()') {{ $t('mensagens.operacao.acoes.cancelar') }}
                div
                    BaseButton.mt-3(
                        type='primary',
                        @click='adicionarUtilizarAreaTotalTerritorio()'
                    ) {{ $t('mensagens.operacao.acoes.adicionar') }}

    .modal-finalizar-cadastro-gleba
        el-dialog.modal-utilizar-area-total-territorio(
            v-if='mostrarModalFinalizarCadastroGleba',
            :title='$t("mensagens.operacao.formularioGleba.dadosGleba")',
            :visible.sync='mostrarModalFinalizarCadastroGleba',
            width='30%',
            :close-on-click-modal='false',
            :show-close='false'
        )
            div
                span.titulo-tabela {{ $t('mensagens.operacao.formularioGleba.areaHa') }}
                div
                    span {{ formularioFinalizarCadastroGleba.glebaArea }}
            div
                el-form(
                    :model='formularioFinalizarCadastroGleba',
                    ref='formularioFinalizarCadastroGleba',
                    :rules='regraFormularioFinalizarCadastroGleba'
                )
                    el-form-item(prop='glebaNome')
                        div
                            span.titulo-tabela.campo_obrigatorio {{ $t('mensagens.operacao.formularioGleba.nomeGleba') }}
                        div
                            el-input(
                                :placeholder='$t("mensagens.operacao.formularioGleba.nomeGleba")',
                                v-model='formularioFinalizarCadastroGleba.glebaNome'
                            )
                    el-form-item(prop='glebaTipo', required)
                        div
                            span.titulo-tabela {{ $t('mensagens.operacao.formularioGleba.tipo') }}
                        div
                            el-radio.modal-utilizar-area-total-territorio__radio(
                                v-model='formularioFinalizarCadastroGleba.glebaTipo',
                                :label='glebaTipo',
                                v-for='(glebaTipo, glebaTipoIndex2) in glebaTipos',
                                :key='glebaTipoIndex2'
                            ) {{ glebaTipo.nome }}
            span.dialog-footer(slot='footer')
                BaseButton.mt-3(
                    @click='cancelarModalFinalizarCadastroGeometriaGleba()'
                ) {{ $t('mensagens.operacao.acoes.cancelar') }}
                BaseButton.mt-3(
                    v-if='glebaEditando',
                    type='primary',
                    @click='finalizarCadastroGleba()'
                ) {{ $t('mensagens.operacao.acoes.salvar') }}
                BaseButton.mt-3(
                    v-else='glebaEditando',
                    type='primary',
                    @click='finalizarCadastroGleba()'
                ) {{ $t('mensagens.operacao.acoes.adicionar') }}

    .modal-cars
        el-dialog(
            :title='$t("mensagens.comuns.carsVinculados")',
            :visible.sync='!!carsSelecionados.length',
            :before-close='fecharModalCars'
        )
            el-table(:data='carsSelecionados')
                el-table-column(
                    property='codigo',
                    :label='$t("mensagens.comuns.numeroDoCAR")'
                )

    .modal-pessoas
        el-dialog(
            :title='$t("mensagens.operacao.pessoasVinculadas")',
            :visible.sync='!!pessoasSelecionadas.length',
            :before-close='fecharModalPessoas'
        )
            el-table(:data='pessoasSelecionadas')
                el-table-column(
                    property='nomeRazaoSocial',
                    :label='$t("mensagens.operacao.tabela.nome")',
                    width='400'
                )
                el-table-column(
                    property='cpfCnpj',
                    :label='$t("mensagens.operacao.tabela.documento")',
                    align='center'
                )

    .modal-sobreposicao
        el-dialog(:visible.sync='mostrarModalSobreposicao', width='580px')
            template(slot='title')
                i.el-icon-warning-outline.formulario-territorio-gleba-operacao--modal__sobreposicao__icone
                span.formulario-territorio-gleba-operacao--modal__sobreposicao__titulo {{ $t('mensagens.operacao.formularioGleba.glebasFinanciadas') }}
            span {{ $t('mensagens.operacao.formularioGleba.identificamos') }} {{ operacoesSobreposicao.length }} {{ labelOperacaoSobreposicao }} {{ $t('mensagens.operacao.formularioGleba.glebasFinanciadasSafra') }}.
            br
            span {{ $t('mensagens.operacao.formularioGleba.verificarOperacoes') }}

            ul.formulario-territorio-gleba-operacao--modal__sobreposicao__lista
                li(
                    v-for='(operacao, index) in operacoesSobreposicao',
                    :key='index'
                )
                    .line(v-if='operacoesSobreposicao.length > 1')
                    span {{ $t('mensagens.operacao.formularioGleba.identificadorOperacao') }}: {{ operacao.identificador }}
                    br
                    span.mt-3 {{ $t('mensagens.operacao.tabela.categoria') }}: {{ operacao.categoria }}

            span.formulario-territorio-gleba-operacao--modal__sobreposicao__footer(
                slot='footer'
            )
                BaseButton.mt-3(@click='fecharModalSobreposicao()') {{ $t('mensagens.operacao.acoes.cancelar') }}
                BaseButton.mt-3(type='primary', @click='continuarFinalizacao()') {{ $t('mensagens.operacao.acoes.continuar') }}
</template>

<script>
import L from 'leaflet';
import 'leaflet-easybutton/src/easy-button.css';
import 'leaflet-easybutton';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw/dist/leaflet.draw';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
import difference from '@turf/difference';
import intersect from '@turf/intersect';
import area from '@turf/area';
import kinks from '@turf/kinks';
import { convertArea, multiPolygon, polygon } from '@turf/helpers';
import { uuid } from 'vue-uuid';
import EventBus from '@/utils/eventBus';

import { configureDrawLocal } from '@/utils/mapa/mapa.draw.full-config.js';
import { DRAW_OPTIONS_GLEBA } from '@/utils/mapa/mapa.draw.options.gleba.js';

import geometryUtils from '@/utils/mapa/geometry.js';

import formatters from '@/utils/formatters';
import { DEFAULT_CONFIG, TILE_LAYER_CONFIG } from '@/utils/mapa/mapa.config.js';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos.js';

import ControleLeafletComComponenteVue from '@/utils/mapa/ControleLeafletComComponenteVue';
import UploadArquivoTerritorioGlebaOperacao from '@/components/operacao/gestao/UploadArquivoTerritorioGlebaOperacao.vue';

import TerritorioService from '@/services/TerritorioService';
import OperacaoService from '@/services/OperacaoService';

import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'FormularioTerritorioGlebaOperacao',

    components: {
        BaseButton
    },

    emits: ['dadosTerritorioGleba'],

    props: {
        dadosEditarOuClonar: {
            type: Object,
            required: false,
            default: null
        },
        dadosVisualizacao: {
            type: Object,
            required: false,
            default: null
        },
        dadosValidarSobreposicao: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        return {
            pesquisa: '',
            pesquisaGleba: '',
            glebas: [],
            glebaTipos: [],
            glebaDesenhada: null,
            glebasEditaveis: new L.FeatureGroup(),
            glebaEditando: false,
            territorio: null,
            territorios: [],
            territoriosAdicionados: [],
            territorioUtilizarAreaTotal: null,
            territorioSelecionadoNovaGlebaOuEdicao: null,
            pessoasSelecionadas: [],
            mostrarModalPessoas: false,
            carsSelecionados: [],
            mostrarModalCars: false,
            mostrarResultado: false,
            glebaAdicionadaMapaPrincipal: {
                geometria: null,
                id: null,
                identificador: null
            },
            mostrarModalModalPrincipal: false,
            editandoGleba: false,
            territorioLoading: false,
            mostrarModalSelecaoGlebaTipo: false,
            regraFormularioGlebaTipos: {
                glebaTipo: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.operacao.formularioGleba.campoObrigatorio'
                        ),
                        trigger: 'change'
                    }
                ]
            },
            regraFormularioFinalizarCadastroGleba: {
                glebaNome: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.operacao.formularioGleba.campoObrigatorio'
                        ),
                        trigger: 'blur'
                    },
                    {
                        min: 3,
                        max: 50,
                        message: this.$t(
                            'mensagens.operacao.formularioGleba.caracteresMinimo'
                        ),
                        trigger: 'blur'
                    }
                ],
                glebaTipo: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.operacao.formularioGleba.campoObrigatorio'
                        ),
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.operacao.formularioGleba.campoObrigatorio'
                        ),
                        trigger: 'change'
                    }
                ]
            },
            formularioGlebaTipo: {
                glebaTipo: null
            },
            formularioFinalizarCadastroGleba: {
                glebaTipo: null,
                glebaNome: null,
                glebaArea: null
            },
            indexTerritorioSelecionadoNovaGleba: 0,
            mostrarModalFinalizarCadastroGleba: false,
            MultiPolygon: multiPolygon,
            Polygon: polygon,
            operacoesSobreposicao: [],
            mostrarModalSobreposicao: false,
            labelOperacaoSobreposicao: '',
            modalOrigemCadastroGleba: ''
        };
    },

    async created() {
        this.territorios = await this.filtrarCadastroGleba('');

        if (
            this.dadosEditarOuClonar &&
            this.dadosEditarOuClonar.territoriosGlebas
        ) {
            this.adicionarTerritoriosEdicao(
                this.dadosEditarOuClonar.territoriosGlebas
            );
        }

        if (
            this.dadosVisualizacao &&
            this.dadosVisualizacao.territoriosGlebas
        ) {
            this.adicionarTerritoriosVisualizacao(
                this.dadosVisualizacao.territoriosGlebas
            );
        }
    },

    methods: {
        remoteMethod(query) {
            this.pesquisa = query;

            setTimeout(() => {
                this.pesquisar();
            }, 800);
        },

        async filtrarCadastroGleba(filtro) {
            const { data } = await TerritorioService.filtrarCadastroGleba(
                filtro
            );
            return data;
        },

        async pesquisar() {
            if (!this.pesquisa) return this.limpar();

            try {
                const data = await this.filtrarCadastroGleba(this.pesquisa);
                this.territorios = data;

                if (!data.length) {
                    this.exibirNotify(
                        'warning',
                        this.$t(
                            'mensagens.operacao.notificacao.semResultadosTextoInformado1'
                        )
                    );
                    return;
                }

                this.mostrarResultado = true;
            } catch (error) {
                this.exibirNotify(
                    'error',
                    this.$t(
                        'mensagens.operacao.notificacao.erroFiltroTerritorio'
                    )
                );
                throw error;
            }
        },

        async pesquisarGleba() {
            try {
                if (!this.pesquisaGleba) return;

                const { data } =
                    await OperacaoService.buscarGlebasPorIdTerritorio(
                        this.territorioSelecionadoNovaGlebaOuEdicao.id,
                        this.pesquisaGleba
                    );
                this.glebas = data;

                setTimeout(() => {
                    this.glebas.forEach(gleba => {
                        const { operacaoIdentificadorGleba, id, geometria } =
                            gleba;
                        this.criarMapaListaGleba(
                            operacaoIdentificadorGleba,
                            id,
                            geometria,
                            this.territorioSelecionadoNovaGlebaOuEdicao
                                .geometria
                        );
                    });
                }, 500);

                if (!data.length) {
                    this.exibirNotify(
                        'warning',
                        this.$t(
                            'mensagens.operacao.notificacao.semResultadosTextoInformado2'
                        ),
                        'top-left'
                    );
                }
            } catch (error) {
                this.exibirNotify(
                    'error',
                    this.$t('mensagens.operacao.notificacao.erroFiltroGleba'),
                    'top-left'
                );
                throw error;
            }
        },

        adicionarTerritoriosEdicao(territorios) {
            territorios.forEach(territorio => {
                this.territoriosAdicionados.push(territorio);
                this.criarMapaPreview(territorio, 'edicao');
                this.atualizarDadosTerritorioGlebaNoComponentePai();
            });
        },

        adicionarTerritoriosVisualizacao(territorios) {
            territorios.forEach(territorio => {
                this.territoriosAdicionados.push(territorio);
                this.criarMapaPreview(territorio, 'visualizacao');
            });
        },

        async adicionarTerritorio() {
            try {
                this.indexTerritorioSelecionadoNovaGleba = null;
                const territorioAdicionado = this.territoriosAdicionados.find(
                    t => t.id === this.territorio.id
                );
                if (!territorioAdicionado) {
                    this.pesquisa = '';
                    this.territorioLoading = true;
                    const { data } =
                        await TerritorioService.buscarCadastroGleba(
                            this.territorio.id
                        );
                    data.glebas = [];
                    this.territoriosAdicionados.push(data);
                    this.criarMapaPreview(data);
                    this.atualizarDadosTerritorioGlebaNoComponentePai();
                    this.territorio = null;
                } else {
                    this.exibirNotify(
                        'warning',
                        this.$t(
                            'mensagens.operacao.notificacao.territorioJaAdicionado'
                        )
                    );
                    this.territorio = null;
                }
            } catch (error) {
                this.territorioLoading = false;
                this.exibirNotify(
                    'error',
                    this.$t(
                        'mensagens.operacao.notificacao.erroBuscaTerritorio'
                    )
                );
                throw error;
            }
        },

        criarMapaPreview(territorio, edicaoOuVisualizacao = false) {
            setTimeout(() => {
                const mapaPreview = this.criarMapaBase(
                    `${territorio.nome}${territorio.id}`
                );
                const mapaPreviewfeatureGroup = new L.FeatureGroup();
                mapaPreviewfeatureGroup.addTo(mapaPreview);

                this.adicionarComponenteFullscreen(mapaPreview);
                this.adicionarComponenteCentralizar(
                    mapaPreview,
                    mapaPreviewfeatureGroup
                );

                const territorioGeometriaLayer = L.geoJSON(
                    territorio.geometria,
                    {
                        style: () => {
                            return getEstiloGeometria('area');
                        }
                    }
                );
                mapaPreviewfeatureGroup.addLayer(territorioGeometriaLayer);
                mapaPreview.fitBounds(mapaPreviewfeatureGroup.getBounds());

                const territorioIndex =
                    this.territoriosAdicionados.indexOf(territorio);

                territorio.mapa = mapaPreview;
                territorio.mapaGrupo = mapaPreviewfeatureGroup;

                this.$set(
                    this.territoriosAdicionados,
                    territorioIndex,
                    territorio
                );

                if (
                    edicaoOuVisualizacao &&
                    territorio.glebas &&
                    territorio.glebas.forEach
                ) {
                    territorio.glebas.forEach(g => {
                        const identificador = uuid.v1();
                        g.identificador = identificador;
                        this.adicionarGeometriaMapa(
                            territorio.mapa,
                            g.geometria,
                            territorio.utilizouAreaTotalTerritorio
                                ? 'operacaoGlebaAreaTotalTerritorio'
                                : 'operacaoGleba',
                            territorio.mapaGrupo,
                            identificador
                        );
                    });
                }

                this.territorioLoading = false;
            }, 500);
        },

        removerTerritorio(territorio) {
            const temp = this.territoriosAdicionados.filter(
                t => t.id !== territorio.id
            );
            this.territorioLoading = true;
            this.territoriosAdicionados = [];

            setTimeout(() => {
                this.territoriosAdicionados = temp;

                this.territoriosAdicionados.forEach(t => {
                    this.criarMapaPreview(t, true);
                });
                this.territorioLoading = false;
            }, 500);

            this.exibirNotify(
                'success',
                territorio.nome +
                this.$t('mensagens.operacao.notificacao.removidoSucesso')
            );

            this.limparDadosGleba();
            this.atualizarDadosTerritorioGlebaNoComponentePai();
        },

        async abrirModalUtilizarAreaTotalTerritorio(territorio, index) {
            await this.buscarGlebaTipos();
            this.mostrarModalSelecaoGlebaTipo = true;
            this.territorioUtilizarAreaTotal = {
                ...territorio,
                index
            };
        },

        async editarUtilizarAreaTotalTerritorio(gleba, territorio, index) {
            await this.buscarGlebaTipos();
            this.mostrarModalSelecaoGlebaTipo = true;
            this.territorioUtilizarAreaTotal = {
                ...territorio,
                index
            };
            const tipoSelecionado = this.glebaTipos.find(
                gt => gt.id === gleba.tipo.id
            );
            this.formularioGlebaTipo.glebaTipo = tipoSelecionado;
        },

        cancelarUtilizarAreaTotalTerritorio() {
            this.territorioUtilizarAreaTotal = null;
            this.mostrarModalSelecaoGlebaTipo = false;
            this.formularioGlebaTipo.glebaTipo = null;
        },

        adicionarUtilizarAreaTotalTerritorio() {
            this.$refs['formularioGlebaTipo'].validate(formularioValido => {
                if (!formularioValido) return;

                if (formularioValido) {
                    this.modalOrigemCadastroGleba = 'areaTotalGleba';
                    this.validarSobreposicaoGlebas();
                }
            });
        },

        continuarAreaTotalGleba() {
            this.mostrarModalSobreposicao = false;

            let territorio = null;

            const gleba = {
                operacaoIdentificadorGleba:
                    this.territorioUtilizarAreaTotal.nome,
                tipo: this.formularioGlebaTipo.glebaTipo,
                area: this.territorioUtilizarAreaTotal.area,
                idTerritorio: this.territorioUtilizarAreaTotal.id,
                id: 'area-total',
                identificador: 'area-total',
                geometria: this.territorioUtilizarAreaTotal.geometria
            };

            if (this.indexTerritorioSelecionadoNovaGleba != null) {
                territorio =
                    this.territoriosAdicionados[
                    this.indexTerritorioSelecionadoNovaGleba
                    ];

                if (
                    this.territorioUtilizarAreaTotal.idTerritorio ===
                    territorio.idTerritorio
                ) {
                    this.territorioUtilizarAreaTotal.glebas = [
                        gleba,
                        ...this.territorioUtilizarAreaTotal.glebas
                    ];
                } else {
                    this.territorioUtilizarAreaTotal.glebas = [
                        gleba,
                        ...territorio.glebas
                    ];
                }
            } else {
                this.territorioUtilizarAreaTotal.glebas = [gleba];
            }

            this.territorioUtilizarAreaTotal.utilizouAreaTotalTerritorio = true;

            this.$set(
                this.territoriosAdicionados,
                this.territorioUtilizarAreaTotal.index,
                this.territorioUtilizarAreaTotal
            );

            this.adicionarGeometriaMapa(
                this.territorioUtilizarAreaTotal.mapa,
                this.territorioUtilizarAreaTotal.geometria,
                'operacaoGlebaAreaTotalTerritorio',
                this.territorioUtilizarAreaTotal.mapaGrupo,
                'area-total'
            );

            this.territorioUtilizarAreaTotal = null;
            this.mostrarModalSelecaoGlebaTipo = false;
            this.formularioGlebaTipo.glebaTipo = null;

            this.atualizarDadosTerritorioGlebaNoComponentePai();
        },

        fecharModalCars() {
            this.carsSelecionados = [];
        },

        fecharModalPessoas() {
            this.pessoasSelecionadas = [];
        },

        adicionarNovaGleba(territorio, territorioIndex) {
            this.territorioSelecionadoNovaGlebaOuEdicao = territorio;
            this.indexTerritorioSelecionadoNovaGleba = territorioIndex;
            this.mostrarModalModalPrincipal = true;
            this.pesquisaGleba = '';

            this.criarMapaPrincipal(territorio);
            this.exibirListaGlebas(territorio);
        },

        highlightGlebaMapaPreviewEnter(row) {
            this.highlightGlebaMapaPreview(row, 'operacaoGlebaHighlight');
        },

        highlightGlebaMapaPreviewLeave(row) {
            const territorio = this.territoriosAdicionados.find(
                territorio => territorio.id === row.idTerritorio
            );
            const tema = territorio.utilizouAreaTotalTerritorio
                ? 'operacaoGlebaAreaTotalTerritorio'
                : 'operacaoGleba';
            this.highlightGlebaMapaPreview(row, tema);
        },

        highlightGlebaMapaPreview(gleba, tema) {
            const territorio = this.territoriosAdicionados.find(
                territorio => territorio.id === gleba.idTerritorio
            );
            const glebaLayer = Object.values(territorio.mapa._layers).find(
                l => l.identificador === gleba.identificador
            );
            glebaLayer.setStyle(getEstiloGeometria(tema));
        },

        async editarGleba(gleba, territorio, territorioIndex) {
            this.territorioSelecionadoNovaGlebaOuEdicao = territorio;
            if (territorio.utilizouAreaTotalTerritorio) {
                this.editarUtilizarAreaTotalTerritorio(
                    gleba,
                    territorio,
                    territorioIndex
                );
            } else {
                gleba.editando = true;
                this.glebaEditando = true;
                this.indexTerritorioSelecionadoNovaGleba = territorioIndex;
                this.mostrarModalModalPrincipal = true;
                this.criarMapaPrincipal(territorio);
                this.exibirListaGlebas(territorio);
            }
        },

        removerGleba(gleba, territorioIndex) {
            const territorio = this.territoriosAdicionados.find(
                t => t.id === gleba.idTerritorio
            );

            const glebasFiltradas = territorio.glebas.filter(
                g => g.id !== gleba.id
            );

            this.territorioLoading = true;
            territorio.glebas = [];

            setTimeout(() => {
                territorio.glebas = glebasFiltradas;
                this.territorioLoading = false;
            }, 500);

            if (territorio.area === gleba.area) {
                territorio.utilizouAreaTotalTerritorio = false;
            }

            const glebaLayer = Object.values(territorio.mapa._layers).find(
                l => l.identificador === gleba.identificador
            );

            if (glebaLayer) {
                territorio.mapa.removeLayer(glebaLayer);
            }

            setTimeout(() => {
                this.atualizarDadosTerritorioGlebaNoComponentePai();
            }, 500);

            this.$set(this.territoriosAdicionados, territorioIndex, territorio);
        },

        exibirListaGlebas(territorio) {
            OperacaoService.buscarGlebasPorIdTerritorio(territorio.id, '').then(
                ({ data }) => {
                    this.glebas = data;
                    setTimeout(() => {
                        this.glebas.forEach(gleba => {
                            const {
                                operacaoIdentificadorGleba,
                                id,
                                geometria
                            } = gleba;
                            this.criarMapaListaGleba(
                                operacaoIdentificadorGleba,
                                id,
                                geometria,
                                territorio.geometria
                            );
                        });
                    }, 500);
                }
            );
        },

        criarMapaListaGleba(
            operacaoIdentificadorGleba,
            id,
            geometria,
            territorioGeometria
        ) {
            var mapa = this.criarMapaBase(operacaoIdentificadorGleba + id);

            const layerGleba = L.geoJSON(geometria, {
                style: () => {
                    return getEstiloGeometria('operacaoGleba');
                }
            });

            const layerTerritorio = L.geoJSON(territorioGeometria, {
                style: () => {
                    return getEstiloGeometria('area');
                }
            });

            var grupo = new L.FeatureGroup();
            grupo.addLayer(layerTerritorio);

            // hack para a layer da gleba ficar na frente da layer do território
            setTimeout(() => {
                layerGleba.bringToFront();
            }, 0);

            grupo.addLayer(layerGleba);
            grupo.addTo(mapa);

            mapa.fitBounds(grupo.getBounds());

            mapa.dragging.disable();
            mapa.scrollWheelZoom.disable();
        },

        centralizarGeometria(mapa, geometriaLayer, callback) {
            mapa.fitBounds(geometriaLayer.getBounds());
            if (callback) {
                callback();
            }
        },

        fecharComponenteUpload() {
            EventBus.$emit('upload-gleba:fechar-componente');
        },

        adicionarGlebaOperacaoAnteriorMapa(gleba) {
            const territorio = this.territoriosAdicionados.find(
                t => t.id === gleba.idTerritorio
            );

            if (territorio.glebas) {
                const glebaFoiAdicionada = territorio.glebas.find(
                    g => g.id === gleba.id
                );

                if (glebaFoiAdicionada) {
                    this.exibirNotify(
                        'warning',
                        this.$t(
                            'mensagens.operacao.notificacao.glebaJaAdicionada'
                        ),
                        'top-left'
                    );
                    return;
                }
            }

            const geometriaLayer = L.geoJSON(gleba.geometria, {
                style: () => {
                    return getEstiloGeometria('operacaoGleba');
                }
            });

            territorio.mapaPrincipal.fire(L.Draw.Event.CREATED, {
                layer: geometriaLayer.getLayers().shift(),
                layerType: 'polygon',
                type: L.Draw.Event.CREATED,
                gleba
            });

            territorio.mapaPrincipal.fitBounds(
                territorio.mapaPrincipalFeature.getBounds()
            );
        },

        adicionarGeometriaUploadArquivoMapa(geoJson) {
            if (
                geoJson.features.length === 1 &&
                (geoJson.features[0].geometry.type === 'Polygon' ||
                    geoJson.features[0].geometry.type === 'MultiPolygon') &&
                geoJson.features[0].geometry.coordinates.length === 1
            ) {
                const geometriaLayer = L.geoJSON(
                    {
                        ...geoJson.features.shift(),
                        type: 'Feature'
                    },
                    {
                        style: () => {
                            return getEstiloGeometria('operacaoGleba');
                        }
                    }
                );

                this.territorioSelecionadoNovaGlebaOuEdicao.mapaPrincipal.fire(
                    L.Draw.Event.CREATED,
                    {
                        layer: geometriaLayer.getLayers().shift(),
                        layerType: 'polygon',
                        type: L.Draw.Event.CREATED,
                        gleba: null
                    }
                );

                this.territorioSelecionadoNovaGlebaOuEdicao.mapaPrincipal.fitBounds(
                    this.territorioSelecionadoNovaGlebaOuEdicao.mapaPrincipalFeature.getBounds()
                );
            } else {
                if (geoJson.features.length > 1) {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.operacao.notificacao.arquivoGeometriaExcessiva'
                        )
                    });
                } else {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.operacao.notificacao.arquivoGeometriaValida'
                        )
                    });
                }
            }

            EventBus.$emit('upload-gleba:fechar-componente');
        },

        adicionarGeometriaMapa(mapa, geometria, tema, grupo, identificador) {
            const geometriaLayer = L.geoJSON(geometria, {
                style: () => {
                    return getEstiloGeometria(tema);
                }
            });

            geometriaLayer.identificador = identificador;

            if (grupo) {
                grupo.addLayer(geometriaLayer);
                grupo.addTo(mapa);
                mapa.fitBounds(grupo.getBounds());
            } else {
                mapa.addLayer(geometriaLayer);
                mapa.fitBounds(geometriaLayer.getBounds());
            }

            return geometriaLayer;
        },

        criarMapaPrincipal(territorio) {
            setTimeout(() => {
                territorio.mapaPrincipal = this.criarMapaBase(
                    'modal-desenhar-gleba__mapa'
                );
                territorio.mapaPrincipalFeature = L.featureGroup();

                this.adicionarComponenteZoom(territorio.mapaPrincipal);
                this.adicionarComponenteUploadArquivo(territorio.mapaPrincipal);
                this.adicionarComponenteCentralizar(
                    territorio.mapaPrincipal,
                    territorio.mapaPrincipalFeature,
                    this.fecharComponenteUpload
                );
                this.adicionarComponenteDesenho(territorio);
                this.adicionarEventosComponenteDesenho(territorio);
                this.adicionarGeometriasGlebasETerritorio(territorio);
            }, 500);
        },

        adicionarGeometriasGlebasETerritorio(territorio) {
            // Adicionando a geometria do território no mapa
            const geometriaTerritorioLayer = L.geoJSON(territorio.geometria, {
                style: () => {
                    return getEstiloGeometria('area');
                }
            });
            territorio.mapaPrincipal.addLayer(geometriaTerritorioLayer);
            territorio.mapaPrincipalFeature.addLayer(geometriaTerritorioLayer);

            // Adicionando a geometria das glebas do mapa
            territorio.glebas.forEach(g => {
                const geometriaGlebaLayer = L.geoJSON(g.geometria, {
                    style: () => {
                        return getEstiloGeometria(
                            g.editando
                                ? 'operacaoGleba'
                                : 'operacaoGlebaDesabilitada'
                        );
                    }
                });
                if (g.editando) {
                    territorio.mapaPrincipal.fire(L.Draw.Event.CREATED, {
                        layer: geometriaGlebaLayer.getLayers().shift(),
                        layerType: 'polygon',
                        type: L.Draw.Event.CREATED,
                        gleba: g
                    });
                } else {
                    territorio.mapaPrincipalFeature.addLayer(
                        geometriaGlebaLayer
                    );
                    territorio.mapaPrincipal.addLayer(geometriaGlebaLayer);
                }
            });

            // Centralizando o mapa nas geometrias
            territorio.mapaPrincipal.fitBounds(
                territorio.mapaPrincipalFeature.getBounds()
            );
        },

        async limpar() {
            this.mostrarResultado = false;
            this.territorios = [];
            this.territorio = '';
        },

        limparDadosNovaGleba() {
            this.pesquisaGleba = '';
            this.glebaAdicionadaMapaPrincipal = {
                geometria: null,
                id: null,
                identificador: null
            };
            this.mostrarModalModalPrincipal = false;
            const territorio =
                this.territoriosAdicionados[
                this.indexTerritorioSelecionadoNovaGleba
                ];
            if (territorio.glebas) {
                territorio.glebas.forEach(g => {
                    g.editando = false;
                });
            }
            this.glebasEditaveis.clearLayers();
            this.glebaEditando = false;
            this.mostrarModalFinalizarCadastroGleba = false;
        },

        limparDadosGleba() {
            this.formularioGlebaTipo.glebaTipo = null;
        },

        async abrirModalFinalizarCadastroGeometriaGleba() {
            if (this.glebaAdicionadaMapaPrincipal.geometria) {
                await this.buscarGlebaTipos();
                const { geometria, tipo, operacaoIdentificadorGleba } =
                    this.glebaAdicionadaMapaPrincipal;
                const glebaPolygon = polygon(geometria.coordinates);
                const areaHa = formatters.formatNumber(
                    convertArea(area(glebaPolygon), 'meters', 'hectares')
                );
                this.formularioFinalizarCadastroGleba.glebaArea = areaHa;
                if (tipo) {
                    const tipoSelecionado = this.glebaTipos.find(
                        gt => gt.id === tipo.id
                    );
                    this.formularioFinalizarCadastroGleba.glebaTipo =
                        tipoSelecionado;
                }
                if (operacaoIdentificadorGleba) {
                    this.formularioFinalizarCadastroGleba.glebaNome =
                        operacaoIdentificadorGleba;
                }
                this.mostrarModalFinalizarCadastroGleba = true;
            } else {
                this.exibirNotify(
                    'warning',
                    this.$t(
                        'mensagens.operacao.notificacao.nenhumaGlebaAdicionada'
                    ),
                    'top-left'
                );
            }
        },

        cancelarModalFinalizarCadastroGeometriaGleba() {
            this.formularioFinalizarCadastroGleba = {
                glebaTipo: null,
                glebaNome: null,
                glebaArea: null
            };
            this.mostrarModalFinalizarCadastroGleba = false;
        },

        finalizarCadastroGleba() {
            this.$refs['formularioFinalizarCadastroGleba'].validate(
                formularioValido => {
                    if (!formularioValido) return;

                    if (formularioValido) {
                        // Verificar se ha intersecção entre as glebas por tipo
                        let interseccaoComTipoNaoPermitido = false;
                        this.territorioSelecionadoNovaGlebaOuEdicao.glebas.forEach(
                            item => {
                                if (
                                    intersect(
                                        this.glebaAdicionadaMapaPrincipal
                                            .geometria,
                                        item.geometria
                                    )
                                ) {
                                    let tipoGlebaInterseccao =
                                        this.formularioFinalizarCadastroGleba
                                            .glebaTipo.id;

                                    // Nao permitir interseccao de gleba com o mesmo tipo
                                    if (tipoGlebaInterseccao === item.tipo.id) {
                                        interseccaoComTipoNaoPermitido = true;
                                    }

                                    // Nao permitir interseccao de gleba com tipo Beneficiado + Garantia
                                    if (
                                        tipoGlebaInterseccao === 3 ||
                                        item.tipo.id === 3
                                    ) {
                                        interseccaoComTipoNaoPermitido = true;
                                    }
                                }
                            }
                        );

                        if (interseccaoComTipoNaoPermitido) {
                            this.$notify.warning({
                                message: this.$t(
                                    'mensagens.operacao.notificacao.interseccaoGleba'
                                )
                            });
                            return;
                        }

                        this.modalOrigemCadastroGleba = 'finalizacaoGleba';
                        this.validarSobreposicaoGlebas();
                    }
                }
            );
        },

        async validarSobreposicaoGlebas() {
            // let idTipoGleba = 0;
            // let geometria;

            // if (this.modalOrigemCadastroGleba === 'finalizacaoGleba') {
            //     idTipoGleba =
            //         this.formularioFinalizarCadastroGleba.glebaTipo.id;
            //     geometria = this.glebaAdicionadaMapaPrincipal.geometria;
            // }

            // if (this.modalOrigemCadastroGleba === 'areaTotalGleba') {
            //     idTipoGleba = this.formularioGlebaTipo.glebaTipo.id;
            //     geometria = this.territorioUtilizarAreaTotal.geometria;
            // }

            // if (
            //     (this.dadosValidarSobreposicao.idCategoria === 1 ||
            //         this.dadosValidarSobreposicao.idCategoria === 2) &&
            //     this.dadosValidarSobreposicao.datasPlantio.length > 0 &&
            //     (idTipoGleba === 1 || idTipoGleba === 3)
            // ) {
            //     const sobreposicao = {
            //         idOperacao: this.dadosValidarSobreposicao.idOperacao
            //             ? this.dadosValidarSobreposicao.idOperacao
            //             : null,
            //         geoJson: geometria,
            //         datasInicioPlantio: []
            //     };

            //     this.dadosValidarSobreposicao.datasPlantio.forEach(plantio => {
            //         sobreposicao.datasInicioPlantio.push({ data: plantio });
            //     });

            //     try {
            //         const { data } =
            //             await OperacaoService.validarSobreposicaoGlebas(
            //                 sobreposicao
            //             );
            //         this.operacoesSobreposicao = data.sobreposicoes;

            //         if (this.operacoesSobreposicao.length > 0) {
            //             this.mostrarModalSobreposicao = true;

            //             this.labelOperacaoSobreposicao = 'operação';
            //             if (this.operacoesSobreposicao.length > 1) {
            //                 this.labelOperacaoSobreposicao = 'operações';
            //             }
            //         } else {
            //             this.continuarFinalizacao();
            //         }
            //     } catch (error) {
            //         this.exibirNotify(
            //             'error',
            //             'Não foi possível validar sobreposições da gleba.'
            //         );
            //         throw error;
            //     }
            // } else {
            //     this.continuarFinalizacao();
            // }
            this.continuarFinalizacao();
        },

        continuarFinalizacao() {
            if (this.modalOrigemCadastroGleba === 'finalizacaoGleba') {
                this.continuarFinalizacaoGleba();
            }

            if (this.modalOrigemCadastroGleba === 'areaTotalGleba') {
                this.continuarAreaTotalGleba();
            }
        },

        continuarFinalizacaoGleba() {
            this.mostrarModalSobreposicao = false;
            const territorio =
                this.territoriosAdicionados[
                this.indexTerritorioSelecionadoNovaGleba
                ];

            const glebaNovaOuEditada = {
                id: this.glebaAdicionadaMapaPrincipal.id,
                idTerritorio: territorio.id,
                operacaoIdentificadorGleba:
                    this.formularioFinalizarCadastroGleba.glebaNome,
                tipo: this.formularioFinalizarCadastroGleba.glebaTipo,
                area: this.formularioFinalizarCadastroGleba.glebaArea,
                identificador: this.glebaAdicionadaMapaPrincipal.identificador,
                geometria: this.glebaAdicionadaMapaPrincipal.geometria,
                editando: false
            };

            // Removendo a gleba antiga do mapa
            territorio.glebas = territorio.glebas
                .map(g => {
                    if (g.editando) {
                        const layerAntiga = Object.values(
                            territorio.mapa._layers
                        ).find(l => l.identificador === g.identificador);
                        if (layerAntiga) {
                            territorio.mapa.removeLayer(layerAntiga);
                        }
                    }
                    return g;
                })
                .filter(g => !g.editando);

            // Adicionando a nova gleba no territorio
            territorio.glebas.push(glebaNovaOuEditada);

            // Adicionando a gleba nova ou editada no mapa
            this.adicionarGeometriaMapa(
                territorio.mapa,
                this.glebaAdicionadaMapaPrincipal.geometria,
                'operacaoGleba',
                territorio.mapaGrupo,
                this.glebaAdicionadaMapaPrincipal.identificador
            );

            // Resetando variáveis apos salvar/editar
            this.mostrarModalFinalizarCadastroGleba = false;
            this.mostrarModalModalPrincipal = false;
            this.glebaAdicionadaMapaPrincipal = {
                geometria: null,
                id: null,
                identificador: null
            };
            this.formularioFinalizarCadastroGleba = {
                glebaTipo: null,
                glebaNome: null,
                glebaArea: null
            };

            this.atualizarDadosTerritorioGlebaNoComponentePai();
        },

        fecharModalSobreposicao() {
            this.mostrarModalSobreposicao = false;
        },

        fecharResultadoPesquisa() {
            setTimeout(() => {
                this.mostrarResultado = false;
                this.territorios = [];
            }, 300);
        },

        criarMapaBase(id) {
            const mapa = L.map(id, {
                maxZoom: DEFAULT_CONFIG.maxZoom,
                minZoom: DEFAULT_CONFIG.minZoom,
                zoomControl: false
            });

            L.tileLayer(TILE_LAYER_CONFIG.url, {
                attributionControl: false
            }).addTo(mapa);

            mapa.attributionControl.setPrefix('');

            return mapa;
        },

        adicionarComponenteZoom(mapa) {
            L.control
                .zoom({
                    position: 'topright',
                    zoomInTitle: this.$t(
                        'mensagens.operacao.formularioGleba.aproximar'
                    ),
                    zoomOutTitle: this.$t(
                        'mensagens.operacao.formularioGleba.afastar'
                    )
                })
                .addTo(mapa);
        },

        adicionarComponenteUploadArquivo(mapa) {
            const config = {
                classeControle: 'leaflet-control-upload-file',
                position: 'topright'
            };

            ControleLeafletComComponenteVue(
                UploadArquivoTerritorioGlebaOperacao,
                mapa,
                {
                    mapa: mapa,
                    callback: this.adicionarGeometriaUploadArquivoMapa
                },
                config
            );
        },

        adicionarComponenteCentralizar(mapa, featureGroup, callback) {
            L.easyButton({
                position: 'topright',
                leafletClasses: true,
                states: [
                    {
                        stateName: 'center',
                        onClick: () =>
                            this.centralizarGeometria(
                                mapa,
                                featureGroup,
                                callback
                            ),
                        title: this.$t(
                            'mensagens.operacao.formularioGleba.centralizar'
                        ),
                        icon: 'mdi mdi-crosshairs-gps centralizar__icon'
                    }
                ]
            }).addTo(mapa);
        },

        adicionarComponenteFullscreen(mapa) {
            mapa.addControl(
                new L.Control.Fullscreen({
                    position: 'topright'
                })
            );
        },

        adicionarComponenteDesenho({ mapaPrincipal }) {
            this.glebasEditaveis = new L.FeatureGroup();
            mapaPrincipal.addLayer(this.glebasEditaveis);

            const drawControl = new L.Control.Draw(
                DRAW_OPTIONS_GLEBA(this.glebasEditaveis)
            );

            configureDrawLocal();
            mapaPrincipal.addControl(drawControl);
        },

        adicionarEventosComponenteDesenho({
            mapaPrincipal,
            mapaPrincipalFeature,
            geometria
        }) {
            const self = this;

            mapaPrincipal.on(L.Draw.Event.CREATED, e => {
                /**
                 * Esse evento é disparado nas seguintes ocasiões:
                 * - Quando um desenho é finalizado pela ferramenta do mapa
                 * - Quando um desenho é editado no mapa
                 * - Quando é adicionado um desenho de gleba de uma operação anterior
                 * - Quando entra no modo de edição de gleba, proveniente da lista de glebas adicionadas
                 */

                const geometriaValida = this.validarGeometria(
                    e.layer.toGeoJSON()
                );
                if (!geometriaValida) {
                    this.exibirNotify(
                        'warning',
                        this.$t('mensagens.operacao.notificacao.erroGeometria'),
                        'top-left'
                    );
                    return;
                }

                const layerGeoJSON = e.layer.toGeoJSON();
                const editando = e.gleba && e.gleba.editando;
                const idGleba = e.gleba && e.gleba.id ? e.gleba.id : null;
                const identificador =
                    e.gleba && e.gleba.identificador
                        ? e.gleba.identificador
                        : uuid.v1();

                if (!editando && self.glebaAdicionadaMapaPrincipal.geometria) {
                    this.exibirNotify(
                        'warning',
                        this.$t(
                            'mensagens.operacao.notificacao.poligonoExcessivo'
                        ),
                        'top-left'
                    );
                    return;
                }

                if (
                    !this.glebaEstaContidaComToleranciaNoTerritorio(
                        layerGeoJSON.geometry,
                        geometria
                    )
                ) {
                    this.exibirNotify(
                        'warning',
                        this.$t('mensagens.operacao.notificacao.glebaContida'),
                        'top-left'
                    );
                    return;
                }

                // if (this.glebasEstaoSeSobrepondo(layerGeoJSON, identificador)) {
                // 	this.exibirNotify('warning', 'A gleba não pode se sobrepor com outra cadastrada anteriormente.', 'top-left');
                // 	return;
                // }

                self.glebaAdicionadaMapaPrincipal = {
                    geometria: layerGeoJSON.geometry,
                    id: idGleba,
                    identificador
                };

                if (editando) {
                    self.glebaAdicionadaMapaPrincipal = {
                        geometria: layerGeoJSON.geometry,
                        id: idGleba,
                        tipo: e.gleba.tipo,
                        operacaoIdentificadorGleba:
                            e.gleba.operacaoIdentificadorGleba,
                        identificador
                    };
                }

                setTimeout(() => {
                    // hack para a layer da gleba ficar na frente da layer do território
                    e.layer.bringToFront();
                }, 0);

                e.layer.identificador = identificador;
                e.layer.podeEditar = true;
                e.layer.on('click', () => {
                    if (e.layer.podeEditar) {
                        e.layer.editing.enable();
                        document
                            .querySelector('.leaflet-draw-edit-edit')
                            .click();
                    }
                });

                if (layerGeoJSON.geometry.type !== 'Point') {
                    const areaHa = this.formatAreaHa(
                        geometryUtils.calcularAreaHaFromLayer(e.layer)
                    );
                    e.layer.bindPopup(
                        '<div>' +
                        this.$t(
                            'mensagens.operacao.formularioGleba.areaPoligono'
                        ) +
                        '<br>' +
                        areaHa +
                        ' (ha)</div>'
                    );
                }

                self.glebasEditaveis.addLayer(e.layer);
                mapaPrincipalFeature.addLayer(e.layer);
            });

            mapaPrincipal.on(L.Draw.Event.EDITED, e => {
                const layers = e.layers;
                if (layers.toGeoJSON().features.length) {
                    const glebaPolygon = polygon(
                        layers.toGeoJSON().features.shift().geometry.coordinates
                    );
                    let territorioPolygon = null;
                    if (geometria.type === 'MultiPolygon') {
                        territorioPolygon = this.MultiPolygon(
                            geometria.coordinates
                        );
                    } else if (geometria.type === 'Polygon') {
                        territorioPolygon = this.Polygon(geometria.coordinates);
                    }

                    layers.eachLayer(layer => {
                        if (layer.toGeoJSON().geometry.type !== 'Point') {
                            const areaHa = this.formatAreaHa(
                                geometryUtils.calcularAreaHaFromLayer(layer)
                            );
                            layer.bindPopup(
                                '<div>' +
                                this.$t(
                                    'mensagens.operacao.formularioGleba.areaPoligono'
                                ) +
                                '<br>' +
                                areaHa +
                                ' (ha)</div>'
                            );
                        }
                    });

                    if (
                        !this.glebaEstaContidaComToleranciaNoTerritorio(
                            glebaPolygon.geometry,
                            territorioPolygon.geometry
                        )
                    ) {
                        // Remove a geometria editada das features
                        self.glebasEditaveis.clearLayers();

                        // Adicionando a geometria antes da edição na featureGroup de gometria editáveis
                        const geometriaLayer = L.geoJSON(
                            self.glebaAdicionadaMapaPrincipal.geometria,
                            {
                                style: () => {
                                    return getEstiloGeometria('operacaoGleba');
                                }
                            }
                        );
                        self.glebasEditaveis.addLayer(
                            geometriaLayer.getLayers().shift()
                        );

                        // Setando parâmetros para redesenhar
                        const parametrosEdicao = {
                            layer: geometriaLayer.getLayers().shift(),
                            layerType: 'polygon',
                            type: L.Draw.Event.CREATED,
                            gleba: {
                                ...self.glebaAdicionadaMapaPrincipal
                            }
                        };

                        // Limpa a var, pois será setada novamente
                        self.glebaAdicionadaMapaPrincipal.geometria = null;

                        // Evento para redesenhar
                        mapaPrincipal.fire(
                            L.Draw.Event.CREATED,
                            parametrosEdicao
                        );

                        self.exibirNotify(
                            'warning',
                            this.$t(
                                'mensagens.operacao.notificacao.glebaContida'
                            ),
                            'top-left'
                        );
                    } else {
                        // Sentando a layer editada
                        self.glebaAdicionadaMapaPrincipal = {
                            ...self.glebaAdicionadaMapaPrincipal,
                            geometria: layers.toGeoJSON().features.shift()
                                .geometry
                        };
                    }
                }
            });

            mapaPrincipal.on(L.Draw.Event.TOOLBARCLOSED, e => {
                if (
                    mapaPrincipalFeature.getBounds &&
                    mapaPrincipalFeature.getBounds()
                ) {
                    mapaPrincipal.fitBounds(mapaPrincipalFeature.getBounds());
                }
                self.fecharComponenteUpload();
            });

            mapaPrincipal.on(L.Draw.Event.TOOLBAROPENED, e => {
                self.fecharComponenteUpload();
            });

            mapaPrincipal.on(L.Draw.Event.DELETESTART, e => {
                Object.values(e.target._layers)
                    .filter(l => l.identificador)
                    .forEach(layer => {
                        layer.podeEditar = false;
                    });
            });

            mapaPrincipal.on(L.Draw.Event.DELETED, e => {
                if (e.layers.getLayers().length) {
                    self.glebaAdicionadaMapaPrincipal.geometria = null;
                    self.glebasEditaveis.removeLayer(e.layers);
                }
            });

            mapaPrincipal.on(L.Draw.Event.DELETESTOP, e => {
                Object.values(e.target._layers)
                    .filter(l => l.identificador)
                    .forEach(layer => {
                        layer.podeEditar = true;
                    });
            });
        },

        glebasEstaoSeSobrepondo(layerGeoJSON, identificador) {
            let soprepondo = false;
            const desenhoGlebaAtual = polygon(
                layerGeoJSON.geometry.coordinates
            );
            this.territorioSelecionadoNovaGlebaOuEdicao.glebas
                .filter(gleba => gleba.identificador !== identificador)
                .some(gleba => {
                    const desenhoGleba = polygon(gleba.geometria.coordinates);
                    const interseccionando = intersect(
                        desenhoGlebaAtual,
                        desenhoGleba
                    );
                    if (interseccionando) {
                        soprepondo = true;
                        return soprepondo;
                    }
                });

            return soprepondo;
        },

        validarGeometria(layerGeoJSON) {
            const layer = polygon(layerGeoJSON.geometry.coordinates);
            return !kinks(layer).features.length;
        },

        glebaEstaContidaComToleranciaNoTerritorio(
            glebaGeometria,
            territorioGeometria
        ) {
            const glebaGeometriaConvertida = this[glebaGeometria.type](
                glebaGeometria.coordinates
            );
            const territorioGeometriaConvertida = this[
                territorioGeometria.type
            ](territorioGeometria.coordinates);

            // Precisa fazer intersecção
            const interseccionando = intersect(
                glebaGeometriaConvertida,
                territorioGeometriaConvertida
            );
            if (!interseccionando) {
                return false;
            }

            // Regra da tolerância
            const diferenca = difference(
                glebaGeometriaConvertida,
                territorioGeometriaConvertida
            );
            if (diferenca) {
                const territorioArea = area(
                    this[territorioGeometria.type](
                        territorioGeometria.coordinates
                    )
                );
                const territorioAreaDezPorcento = territorioArea * (10 / 100);
                const glebaAreaFora = area(diferenca);
                return territorioAreaDezPorcento > glebaAreaFora;
            }
            return true;
        },

        atualizarDadosTerritorioGlebaNoComponentePai() {
            const retorno = [];
            const territoriosValidados = [];

            this.territoriosAdicionados.forEach(territorio => {
                if (territorio.glebas && territorio.glebas.forEach) {
                    /**
                     * VALIDO: Caso o território possui ao menos uma gleba
                     * INVÁLIDO: Caso o território não possui ao menos uma gleba
                     */
                    territoriosValidados.push(
                        territorio.glebas.length ? 'valido' : 'invalido'
                    );

                    const dados = {
                        idTerritorio: territorio.id,
                        utilizouAreaTotalTerritorio:
                            territorio.utilizouAreaTotalTerritorio,
                        glebas: []
                    };

                    territorio.glebas.forEach(g => {
                        dados.glebas.push({
                            nome: g.operacaoIdentificadorGleba,
                            idTipo: g.tipo.id,
                            geometria: g.geometria
                        });
                    });

                    retorno.push(dados);
                } else {
                    // O território não possui uma gleba
                    territoriosValidados.push('invalido');
                }
            });

            let retornoValidado = [];

            // Caso não exista territórios inválidos retorna  os dados formatados
            if (!territoriosValidados.find(v => v === 'invalido')) {
                retornoValidado = retorno;
            }

            // Atualiza os dados no pai
            this.$emit('dadosTerritorioGleba', retornoValidado);
        },

        async buscarGlebaTipos() {
            try {
                if (!this.glebaTipos.length) {
                    const { data } = await OperacaoService.buscarTipoGleba();
                    this.glebaTipos = data;
                }
            } catch (error) {
                this.exibirNotify(
                    'error',
                    this.$t('mensagens.operacao.notificacao.erroTipoGleba'),
                    'top-left'
                );
                throw error;
            }
        },

        exibirNotify(tipo, message, position = 'top-right') {
            this.$notify[tipo]({
                message,
                position
            });
        },

        async verificarResultadoTerritorios() {
            if (this.territorios.length > 0) {
                this.mostrarResultado = true;
            } else {
                this.territorios = await this.filtrarCadastroGleba('');
                this.mostrarResultado = true;
            }
        },

        formatAreaHa(areaHa) {
            if (!areaHa) return;
            const area = String(areaHa);
            if (area.includes(',')) {
                let n = areaHa.split(',', 2);
                return n[0] + ',' + n[1].substr(2);
            }
            const options = {
                style: 'decimal',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            };
            const formatNumber = new Intl.NumberFormat('pt-BR', options);
            return formatNumber.format(areaHa);
        },

        gerarIdMapa(identificadorGleba, idGleba) {
            return identificadorGleba + '' + idGleba;
        }
    }
};
</script>

<style lang="scss">
.titulo {
    font-size: 14px;
    color: dimgray;
    padding-top: 10px;
    padding-bottom: 10px;
}

.formulario-territorio-gleba-operacao--visualizar {
    margin: 0 !important;
}

#formulario-territorio-gleba-operacao {
    display: flex;
    flex-direction: column;
    font-family: 'Roboto', sans-serif;

    .formulario-dados-territorio-gleba {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 20px;
        padding: 10px 20px 20px 20px;
        background-color: var(--white);
        border-radius: 5px;

        h3 {
            font-size: 18px;
            color: #3b3b3b;
        }

        .campo-pesquisa {
            width: 100%;
            height: 32px;
            border-radius: 5px;
            position: relative;

            .campo-pesquisa__resultado {
                position: absolute;
                width: 100%;
                z-index: 2;

                ul {
                    list-style: none;
                    padding: 8px 0 8px 24px;
                    position: relative;
                    z-index: 42;
                    margin-top: 5px;
                    border-radius: 5px;
                    background-color: var(--white);
                    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

                    li {
                        padding-left: 18px;
                        margin-top: 5px;
                        cursor: pointer;
                    }
                }
            }
        }

        .lista-territorio {
            z-index: 1;
            display: flex;
            flex-direction: column;
            gap: 20px;

            h3 {
                font-size: 16px;
                color: #3b3b3b;
            }

            .el-table th.el-table__cell > .cell {
                font-size: 14px;
            }

            strong {
                color: var(--primary);
                font-size: 14px;
            }

            .titulo-tabela {
                color: var(--primary);
                font-size: 14px;
            }

            p {
                font-size: 14px;
                word-break: break-word;
            }

            .lista-territorio__body {
                display: flex;
                flex-direction: row;
                gap: 20px;

                .lista-territorio__mapa {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;

                    .lista-territorio__mapa-preview {
                        width: 100%;
                        height: 200px;
                        border-radius: 5px;
                    }
                }

                .lista-territorio__actions {
                    display: flex;
                    justify-content: space-between;
                }

                .lista-territorio__primeiro-car {
                    p {
                        word-break: break-all;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }

                .lista-territorio__nome {
                    p {
                        word-break: break-all;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }

                .lista-glebas {
                    .lista-glebas__header {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 20px;

                        h3 {
                            font-size: 16px;
                            color: #3b3b3b;
                        }
                    }

                    .lista-glebas__table {
                        .lista-glebas__actions {
                            display: flex;
                            gap: 10px;
                        }

                        .el-table th {
                            color: var(--primary);
                            font-size: 14px;
                            font-weight: map-get($font-weight, normal);
                        }
                    }
                }
            }
        }
    }

    .modal-desenhar-gleba {
        #modal-desenhar-gleba__mapa {
            width: 100%;
            height: 100vh;
        }

        .modal-desenhar-gleba__list {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 20px 20px 0 20px;
            width: 35%;

            .modal-desenhar-gleba-list__content {
                max-height: 88vh;
                overflow-y: scroll;

                h3 {
                    font-size: 16px;
                    color: #3b3b3b;
                    margin-bottom: 20px;
                }

                span {
                    margin-left: 5px;
                }

                .modal-desenhar-gleba-list__item {
                    margin: 20px 0;
                    border: 1px solid var(--black) 00021;
                    border-radius: 5px;
                    padding: 10px;
                    color: var(--primary);

                    .modal-desenhar-gleba-list__mapa {
                        width: 100%;
                        height: 250px;
                        margin-bottom: 5px;
                    }

                    .modal-desenhar-gleba-list__button {
                        display: flex;
                        justify-content: flex-end;
                    }
                }
            }

            .modal-desenhar-gleba__button {
                display: flex;
                justify-content: space-between;
                margin-bottom: 20px;
            }
        }

        .el-dialog__body {
            display: flex;
            padding: initial !important;
            color: #3b3b3b;
        }

        .el-dialog__header {
            padding: initial !important;
            padding-bottom: initial !important;
        }
    }

    .modal-utilizar-area-total-territorio {
        .modal-utilizar-area-total-territorio__radio {
            margin-right: 10px !important;
            color: var(--primary);
        }

        .el-dialog__footer {
            .dialog-footer {
                display: flex;
                justify-content: space-between;
            }
        }

        .el-dialog__title {
            font-size: 16px !important;
            color: #3b3b3b;
        }

        .el-dialog__body {
            font-size: 14px !important;
            color: var(--primary);
            padding: 10px 20px !important;
        }
    }

    .lista-vazia {
        font-size: 14px;
        color: var(--secondary-font-color);
        font-family: 'Roboto', sans-serif;
        padding-left: 10px !important;
    }

    .isCursorPointer {
        cursor: pointer;
    }

    .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
        background-color: #f3f3f3;
    }

    .el-table--group,
    .el-table--border {
        border-radius: 5px;
    }

    .el-table--border {
        border-right: none;
        border-bottom: 1px solid #ebeef5;
    }

    .el-table--border .el-table__cell {
        border-right: none;
    }

    .leaflet-bar a {
        color: #404040;
    }

    .leaflet-top.leaflet-right {
        padding-left: 415px;
    }

    .leaflet-draw-tooltip-subtext {
        color: var(--white) !important;
        font-weight: bold !important;
    }

    .leaflet-div-icon {
        background: orange;
        border: 3px solid var(--white);
        border-radius: 10px;
    }

    .el-badge__content.is-fixed {
        right: 0 !important;
    }

    .centralizar__icon {
        color: #404040;
    }

    .formulario-territorio-gleba-operacao--modal__sobreposicao__icone {
        font-size: 24px;
        color: #d7bc25;
        padding-right: 20px;
    }

    .formulario-territorio-gleba-operacao--modal__sobreposicao__titulo {
        font-size: 18px;
        color: var(--var(--black));
        font-weight: 500;
    }

    .dialog-footer {
        border-top: 1px solid var(--default-border-color);
        display: flex;
        justify-content: space-between;
    }

    ul.formulario-territorio-gleba-operacao--modal__sobreposicao__lista {
        overflow: auto;
        max-height: 150px;
        margin-top: 50px;
    }

    .formulario-territorio-gleba-operacao--modal__sobreposicao__lista {
        overflow-y: scroll;
        list-style: none;
        padding-inline-start: 0px;
        margin: 0;
        padding: 0;

        li {
            padding-top: 15px;
        }
    }

    .formulario-territorio-gleba-operacao--modal__sobreposicao__footer {
        border-top: 1px solid var(--default-border-color);
        display: flex;
        justify-content: space-between;
        margin-top: 55px;
    }

    .line {
        margin-bottom: 15px;
        border-bottom: 1px solid #8c8e91;
    }

    .campo_obrigatorio::before {
        content: '* ';
        color: red;
    }

    .campo_obrigatorio {
        font-size: 14px;
        color: var(--primary);
        font-weight: normal !important;
    }
}
</style>
